// extracted by mini-css-extract-plugin
export default {"button":"ToolBtn_button__cR5H0","green":"ToolBtn_green__CF3Qk","red":"ToolBtn_red__1B8X3","yellow":"ToolBtn_yellow__YPn0F","blue":"ToolBtn_blue__PmCXr","grey":"ToolBtn_grey__DQcyY"};